export const formattedPrice = (price?: string): string => {  
  if (price) {
    const formattedPrice = new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      currencyDisplay: 'narrowSymbol',
    })
      .format(parseFloat(price))
      .replace('$', '');

    return formattedPrice;
  }

  return '0';
};

export const formattedPercentage = (percentage?: string): string => {
  if (percentage) {
    const percentageValue = parseFloat(percentage) / 100;

    return new Intl.NumberFormat('es-AR', {
      style: 'percent',
      minimumFractionDigits: 2,
    }).format(percentageValue);
  }

  return '%0';
};

export const formatNumberAR = (value: string): string => {
  const number = Number(value);
  return new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};

export const renderCurrency = (value: string | number) => {
    return `$ ${formattedPrice(value.toString())}`
}
